import { Injectable } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { RouterStateSnapshot, TitleStrategy } from '@angular/router'
import { TranslateService } from '@ngx-translate/core'
import { PageTitleService } from '../services/page-title.service'

// Drives the per-page heading/tab title from each route's `title` (a translate KEY). Keeps the
// key on PageTitleService (the shell's <h1> binds to it) and sets the translated browser title.
@Injectable({ providedIn: 'root' })
export class TranslatedTitleStrategy extends TitleStrategy {
  constructor(
    private readonly title: Title,
    private readonly translate: TranslateService,
    private readonly pageTitle: PageTitleService
  ) {
    super()
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const key = this.buildTitle(snapshot) || 'App-Name'
    this.pageTitle.titleKey.set(key)
    // translate.get resolves once the language file is loaded (handles first navigation).
    this.translate.get(key).subscribe((t) => this.title.setTitle(t || 'Hema'))
  }
}
